var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Creative",
    transform: "translate(-3059 -2674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_3",
    "data-name": "Exclusion 3",
    d: "M10501.886-23170.006H10492a3,3,0,0,1-3-3V-23189a3.007,3.007,0,0,1,3-3h9.883a3,3,0,0,1,3,3V-23173A3,3,0,0,1,10501.886-23170.006Zm-7.9-6.652a1.221,1.221,0,0,0-1.216,1.223,1.219,1.219,0,0,0,1.216,1.221h5.926a1.222,1.222,0,0,0,1.222-1.221,1.224,1.224,0,0,0-1.222-1.223Zm0-3.662a1.221,1.221,0,0,0-1.216,1.223,1.221,1.221,0,0,0,1.216,1.223h5.926a1.224,1.224,0,0,0,1.222-1.223,1.224,1.224,0,0,0-1.222-1.223Z",
    transform: "translate(-7423.441 25869.004)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9152",
    "data-name": "Rectangle 9152",
    width: 28,
    height: 28,
    transform: "translate(3059 2674)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreative);
export default __webpack_public_path__ + "static/media/creative.2b1f680396f733eb4a0717080ada77d6.svg";
export { ForwardRef as ReactComponent };